import config from '../config';
import _ from 'lodash';

// eslint-disable-next-line no-undef
let apiURL = process.env.REACT_APP_DEV_SERVER_URL;
let exactClientID = process.env.REACT_APP_DEV_EXACT_CLIENT_ID;
let exactRedirectURL = process.env.REACT_APP_DEV_EXACT_REDIRECTION_URL;


export const getAPIURL = (envConfig) => {
  const environment = _.toLower(_.trim(String(envConfig || "")));

  if (_.isEqual(environment, 'dev')) {
    apiURL = process.env.REACT_APP_DEV_SERVER_URL;
    exactClientID = process.env.REACT_APP_DEV_EXACT_CLIENT_ID;
    exactRedirectURL = process.env.REACT_APP_DEV_EXACT_REDIRECTION_URL;
  } else if (_.isEqual(environment, 'acc')) {
    apiURL = process.env.REACT_APP_ACC_SERVER_URL;
    exactClientID = process.env.REACT_APP_ACC_EXACT_CLIENT_ID;
    exactRedirectURL = process.env.REACT_APP_ACC_EXACT_REDIRECTION_URL;
  } else if (_.isEqual(environment, 'prod')) {
    apiURL = process.env.REACT_APP_PROD_SERVER_URL;
    exactClientID = process.env.REACT_APP_PROD_EXACT_CLIENT_ID;
    exactRedirectURL = process.env.REACT_APP_PROD_EXACT_REDIRECTION_URL;
  }
  
}
getAPIURL(_.get(config, 'environment', ""));
export const API_URL = apiURL;
export const EXACT_CLIENT_ID = exactClientID;
export const EXACT_REDIRECTION_URL = exactRedirectURL;


export const formatter = new Intl.NumberFormat("nl-NL", {
  currency: "EUR",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export const dateFormats = {
  defaultFormat: "DD-MM-YYYY",
  datePickerFormat: "dd-MM-yyyy",
};

export const PAGINATION_PAGE_SIZE = 10;
// These options will be used in multiple places
export const dropdownValueYesNo = [
  { key: "no", value: false },
  { key: "yes", value: true },
];
export const dropdownValueYesNoNeumeric = [
  { key: "no", value: 0 },
  { key: "yes", value: 1 },
];
export const generalValidationMessage = "Please enter valid value";
export const statusList = ["Nee", "Ja", "Prospect", "Wachtruimte"];
export const statusList2 = ["Nee", "Ja"];
export const StatusEnumValue = {
  Nee: 0,
  Ja: 1,
  Prospect: 2,
  Wachtruimte: 3,
};
export const statusOptions = [
  { key: "Nee", value: 0 },
  { key: "Ja", value: 1 },
  { key: "Prospect", value: 2 },
  { key: "Wachtruimte", value: 3 },
];
export const setDropdownFormatValue = (value = "", options = []) => {
  if (typeof value === "object") {
    return value;
  } else {
    let selectedOption = options?.filter((option) => option.value === value);
    if (selectedOption.length) {
      return selectedOption[0];
    } else {
      return null;
    }
  }
};

export const AssignCertificatesOptions = [
  "100% OH",
  "Checked & go",
  "Label 2",
  "Label 3",
  "Label 4",
];
export const BornOptions = [
  { key: "Manual", value: "Manual" },
  { key: "Hexon", value: "Hexon" },
  { key: "Autosoft", value: "Autosoft" },
  { key: "Source3", value: "Source3" },
  { key: "Source4", value: "Source4" },
  { key: "Source5", value: "Source5" },
  { key: "Admin", value: "Admin" },
  { key: "Import csv", value: "Import csv" },
  { key: "Aftersales Formulier", value: "Aftersales Formulier" },
  { key: "Aftersales API", value: "Aftersales API" },
];
export const AssignCertificates = [
  { key: "100% OH", value: 0 },
  { key: "Checked & go", value: 1 },
  { key: "Label 2", value: 2 },
  { key: "Label 3", value: 3 },
  { key: "Label 4", value: 4 },
];
export const NewAssignCertificates = [
  {
    "key": "100% onderhouden",
    "value": "Status_100OH",
    "id": 1
  },
  {
    "key": "BOVAG Onderhoudsvrij",
    "value": "Status_Checked_Go",
    "id": 2
  },
  {
    "key": "BOVAG Import Tellercheck",
    "value": "Status_Label3",
    "id": 3
  },
  {
    "key": "BOVAG Garantie",
    "value": "Status_Label4",
    "id": 4
  },
  {
    "key": "Keurmerk5",
    "value": "Status_Label5",
    "id": 5
  }
];
export const GroupList = [
  { key: "Group1", value: 0, email: "abc@dfg.in" },
  { key: "Group2", value: 1, email: "abcd@efg.in" },
  { key: "Group3", value: 2, email: "abc@xyz.in" },
  { key: "Group4", value: 3, email: "abc@bcd.in" },
];
export const DealersNameList = [
  { key: "Autobedrijf Roetert4", value: 0 },
  { key: "Dealer2", value: 1 },
  { key: "Dealer3", value: 2 },
  { key: "Dealer4", value: 3 },
  { key: "Dealer5", value: 4 },
];
export const getDropDownValue = (value, options = []) => {
  let isValueObj = typeof value === "object";
  if (isValueObj) {
    value = value.value;
  }
  let selectedOption = options.filter((option) => option.value === value);
  if (selectedOption.length) {
    return {
      key: selectedOption[0].key,
      value: selectedOption[0].value,
    };
  } else {
    return null;
  }
};

export const getValueKey = (id = [], options = []) => {
  if (id != null) {
    let certificateList = [];
    id.map((i) => {
      let selectedOption = options.filter((option) => option.id === parseInt(i, 10));
      return certificateList.push(selectedOption[0]);
    });
    return certificateList;
  } else {
    return [];
  }
};
export const dateInputValidation = (input, date) => {
  const dateStrings = input.value.split("-");
  const numbers = dateStrings.map(Number);
  // eslint-disable-next-line no-unused-vars
  const [day, month, year] = numbers;

  if (input.value && numbers.some((number) => isNaN(number))) {
    return false; //in case user enter something other than digits
  }

  if (month > 12 || month < 0) return false; //month < 0 in case user want to type 01

  if (day < 0 || (date && day > date.day) || day > 31) return false;

  if (dateStrings.some((val) => val.startsWith("00"))) return false;
  return true;
};

export const DutchMonths = [
  "jan",
  "febr",
  "mrt",
  "apr",
  "mei",
  "juni",
  "juli",
  "aug",
  "sep",
  "okt",
  "nov",
  "dec",
];
export const DutchWeekDays = ["zo.", "ma.", "di.", "wo.", "do.", "vr.", "za."];

export const downloadCsv = (fileData, name) => {
  const linkSource = `data:text/csv;base64,${fileData}`;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.style.display = "none";
  downloadLink.download = name?.endsWith(".csv") ? name : `${name}.csv`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};